import { useListFetch } from '../../hooks';
import { getCampaignMonitoring } from '../../api';
import type { CampaignMonitoringItemType } from '../../api';
import type { CampaignMonitoringResponse } from '../../api';
import type { GetCampaignMonitoringFilters } from '../../api';

export type ItemType = CampaignMonitoringItemType & {
  latest_contact_state_enum?: string;
};
export type MonitoringColumns = CampaignMonitoringResponse['columns'];

export const useCampaignMonitoring = (id: string) => {
  const result = useListFetch<ItemType, GetCampaignMonitoringFilters>(
    async ({ sortStr, filters, pagination }) => {
      const result = await getCampaignMonitoring(id, {
        filters,
        sort: sortStr,
        page: pagination,
      });

      return {
        ...result,
        data: result.data.map(item => ({
          ...item,
          latest_contact_state_enum: item.latest_contact_state,
        })),
      };
    },
    {
      deps: [id],
      resultKey: 'data',
      initialPageSize: 50,
      initialFilters: { latestContactStateEnum: undefined },
      withQueryParams: true,
      // storageKey: 'use-campaign-monitoring-list',
    }
  );

  return {
    ...result,
    nodes: result.nodes || [],
    rawData: result.rawData as CampaignMonitoringResponse | null,
  } as ReturnType<typeof useListFetch<ItemType, GetCampaignMonitoringFilters>>;
};
